import {authEvents} from "@/shared/lib/events";

export const requestLogin = () => authEvents.loginRequired.emit();
